import { Color3, type Scene } from "@babylonjs/core";
import type { IslandTheme } from "@tiny-seas/shared";
import { PALETTE, type Materials } from "./materials.ts";
import { spawnModel, type ModelInstance, type SceneryName } from "./models.ts";
import { TERRAIN } from "./themes.ts";

const themes = new Map<IslandTheme, Readonly<Record<string, string>>>();

/** The world and asset lab use the same geometry, surface families and theme tints. */
export function spawnScenery(scene: Scene, mats: Materials, name: SceneryName, theme: IslandTheme): ModelInstance {
  let colors = themes.get(theme);
  if (!colors) {
    const terrain = TERRAIN[theme];
    const darkTimber = theme === "volcanic" || theme === "marsh";
    colors = Object.freeze({
      rock: terrain.rock,
      rockDark: Color3.FromHexString(terrain.rock).scale(0.78).toHexString(),
      sand: terrain.sand, wetSand: terrain.wetSand,
      grass: terrain.grass, grassDark: terrain.grassDark, dirt: terrain.grassDark,
      snow: PALETTE.snow,
      wood: darkTimber ? PALETTE.woodDark : PALETTE.wood,
      woodLight: darkTimber ? PALETTE.wood : PALETTE.woodLight,
      woodDark: darkTimber ? Color3.FromHexString(PALETTE.woodDark).scale(0.85).toHexString() : PALETTE.woodDark,
    });
    themes.set(theme, colors);
  }
  return spawnModel(scene, mats, name, {
    colors,
    materials: { lamp: mats.get("lamp"), lava: mats.get("lava", { emissive: 2 }) },
  });
}
